<template>
  <v-container class="pt-0">
    <listMissionVertical
      :dataItems="dataItems"
      :site="site"
      class="mt-2"
      :status="null"
      :isOverview="false"
    ></listMissionVertical>

    <div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <div v-if="!dataItems.length">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>
  </v-container>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import Axios from "@/config/customer-service";
import moment from "moment";
import { mapState } from "vuex";
import listMissionVertical from "@/components/listMissionVertical.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    InfiniteLoading,
    listMissionVertical,
  },
  data: () => ({
    dataItems: [],
    next_page_url: "",
    infiniteId: +new Date(),
  }),
  created() {},
  methods: {
    infiniteHandler($state) {
      this.isAppLoading(true);
      Axios.get("mission/listMission", {
        params: {
          category: "all",
          tag_id: this.$route.params.id,
          cursor: this.next_page_url,
        },
      })
        .then(({ data }) => {
          if (data.data.data.length) {
            let has_more = data.data.has_more;
            this.dataItems = this.dataItems.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@900&display=swap");

::v-deep .v-btn__content {
  display: flex;
  flex-direction: column;
}
::v-deep .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}
::v-deep .v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
::v-deep .v-slide-group__content {
  justify-content: center !important;
}
.bar-header {
  height: 150px;
  font-size: 14px;
}
.title-mission {
  line-height: 1.3;
}
.rowActive {
  position: relative;
}
.expire-date {
  line-height: 0.3;
  position: absolute;
  bottom: 0px;
}
</style>
